<template>
  <transition name="el-fade-in" mode="out-in">
    <HolaconLottie v-if="createLoading == 'created'" key="create-subevent-loading" />
    <el-row :gutter="10" v-else key="create-subevent-content">
      <div class="attendee-subevent-section" v-if="products.length > 0">
        <div class="subevent-item" v-for="product in products" :key="product.id">
          <div class="container">
            <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.additionalProductName") }}</span>
            <span>
              <strong>{{ getProduct(product.additionalProductId) != null ? getProduct(product.additionalProductId).title : 'Ürün bulunamadı.' }}</strong>
            </span>
            <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeSubEventRegistration.registrationDate") }}</span>
            <span>
              <b>{{ $moment(product.createDate).format(dateFormatEvent($store.state.event.event.dateFormat) + " " + timeFormatEvent($store.state.event.event.timeFormat)) }}</b>
            </span>
            <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeSubEventRegistration.confirmationStatus") }}</span>
            <el-dropdown placement="bottom-start" @command="handleCommand">
              <span class="status" :class="[{ pending: product.status == 0 }, { confirmed: product.status == 1 }, { rejected: product.status == 2 }]">
                <i class="fas fa-clock" v-if="product.status == 0"></i>
                <i class="fas fa-check-circle" v-if="product.status == 1"></i>
                <i class="fas fa-times-circle" v-if="product.status == 2"></i>
                {{ getEnumsDisplay("SubEventRegistrationStatus", product.status) }}
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="status-pending-approve" v-if="product.status != 1" :command="{ subevent: product, status: 1 }"> <i class="fas fa-check"></i> {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeSubEventRegistration.confirm") }} </el-dropdown-item>
                <el-dropdown-item class="status-pending-reject" v-if="product.status != 2" :command="{ subevent: product, status: 2 }"> <i class="fas fa-times"></i> {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeSubEventRegistration.reject") }} </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="attendee-subevent-edit">
              <!-- <el-tooltip class="item" effect="dark" :content="$t('event.buttons.delete')" placement="top-start">
                <el-popconfirm :title="$t('generic.deleteSure')" :cancel-button-text="$t('generic.operationCancel')" :confirm-button-text="$t('generic.deleteYes')" icon-color="red">
                  <el-button type="danger" size="small" icon="fas fa-trash" slot="reference" circle></el-button>
                </el-popconfirm>
              </el-tooltip> -->
            </div>
          </div>
        </div>
      </div>
      <el-alert v-else type="info" :show-icon="true" :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeProductRegistration.noProduct')" style="border-radius:8px" :closable="false"></el-alert>
    </el-row>
  </transition>
</template>

<script>
import QuestionItem from "../../register-form/Inputs/QuestionItem.vue";
export default {
  components: {
    QuestionItem
  },
  props: ["data"],
  data() {
    return {
      products: [],
      createLoading: false,
      timeout: null,
      showSubEventDetails: false
    };
  },
  methods: {
    getProduct(id){
     return this.productList.find(x => x.id == id);
    },
    async handleCommand(command) {
      if (command.status == 1) {
        var confirm = await this.$store.dispatch("participantConfirmProduct", command.subevent.id);
        if (!confirm.data.alert.hasError) {
          this.$emit("refresh");
        }
      }
      if (command.status == 2) {
        var cancel = await this.$store.dispatch("participantCancelProduct", command.subevent.id);
        if (!cancel.data.alert.hasError) {
          this.$emit("refresh");
        }
      }
    },
    getSubEvent(id) {
      return this.$store.state.subevents.items.find(x => x.id == id);
    }
  },
  computed: {
    productList() {
      return this.$store.getters.getProducts;
    }
  },
  async created() {
    if (this.timeout != null) clearTimeout(this.timeout);
    this.createLoading = "created";
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getProducts");
      this.createLoading = false;
    }, 500);

    if (this.data != null && this.data != undefined) {
      this.products = this.data
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/participants/ParticipantDetails/AttendeeProductRegistration.vue